import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {
    unfinished: 0,
    unreadcount: 0
  },
  mutations: {
    updateUnfinished (state, val) {
      state.unfinished = val
    },
    updateUnreadcount (state, val) {
      state.unreadcount = val
    }
  },
  actions: {
    getmsgs ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/getmsgs',
        obj,
        callback
      )
    },
    getscheid ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.get,
        '/cmpapi/getscheid',
        obj,
        callback
      )
    },
    setmsgread ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setmsgread',
        obj,
        callback
      )
    },
    setschedone ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/setschedone',
        obj,
        callback
      )
    },
    getsches ({ context, state }, obj, callback) {
      return utilits.httpRequest(
        utilits.post,
        '/cmpapi/getsches',
        obj,
        callback
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/msg.js